import { render, staticRenderFns } from "./FeaturePage.vue?vue&type=template&id=1d187da5&"
import script from "./FeaturePage.vue?vue&type=script&lang=js&"
export * from "./FeaturePage.vue?vue&type=script&lang=js&"
import style0 from "./FeaturePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports